module.exports = __webpack_public_path__ + "static/img/3.b0204f5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/10/zh/3.png
// module id = kSsE
// module chunks = 0